import { FC } from 'react';

import { BeneficiaryRelationsModal } from './containers/BeneficiaryRelationsModal';
import { ConfirmModal } from './containers/ConfirmModal';
import { ConfirmModalV2 } from './containers/ConfirmModalV2';
import { DelegateToModal } from './containers/DelegateToModal';
import { DeleteAssetsConfirm } from './containers/DeleteAssetsConfirm';
import { DeletePersonalIdentifiersConfirm } from './containers/DeletePersonalIdentifiersConfirm';
import { DeletePrivateDocumentConfirm } from './containers/DeletePrivateDocumentConfirm';
import { EditAddressModal } from './containers/EditAddressModal';
import { EditCommentModal } from './containers/EditComment';
import { ExtractModal } from './containers/ExtractModal';
import { FastCreateBeneficiaryModal } from './containers/FastCreateBeneficiaryModal';
import { FastCreateContactModal } from './containers/FastCreateContactModal';
import { FilePreviewModal } from './containers/FilePreviewModal';
import { InboxEmailConfigModal } from './containers/InboxEmailConfigModal';
import { InboxEmailInfoModal } from './containers/InboxEmailInfoModal';
import { AccessErrorModal } from './containers/interwill/AccessErrorModal';
import { AccessInterwillModal } from './containers/interwill/AccessInterwillModal';
import { AccessTutorialModal } from './containers/interwill/AccessTutorialModal';
import { AddExecutorModal } from './containers/interwill/AddExecutorModal';
import { AddMessageModal } from './containers/interwill/AddMessageModal';
import { AddVideoVerificationModal } from './containers/interwill/AddVideoVerificationModal';
import { AddWitnessModal } from './containers/interwill/AddWitnessModal';
import { AssetDistributionModal } from './containers/interwill/AssetDistributionModal';
import { CitezenshipModal } from './containers/interwill/CitizenshipModal';
import { ConfirmApprovalModal } from './containers/interwill/ConfirmApprovalModal';
import { ConfirmHandoverModal } from './containers/interwill/ConfirmHandoverModal';
import { CreateBeneficiaryModal } from './containers/interwill/CreateBeneficiaryModal';
import { CreateBeneficiaryModalV2 } from './containers/interwill/CreateBeneficiaryModalV2';
import { InterwillCreateEntityModal } from './containers/interwill/CreateEntityModal';
import { CreatePersonalIdentifierModal } from './containers/interwill/CreatePersonalIdentifierModal';
import { DeleteTheWillModal } from './containers/interwill/DeleteTheWillModal';
import { DocumentDetailsModal } from './containers/interwill/DocumentDetailsModal';
import { DocumentGalleryModal } from './containers/interwill/DocumentGallery';
import { EditUnregBeneficiaryModal } from './containers/interwill/EditUnregBeneficiaryModal';
import { ExcludedPersonsModal } from './containers/interwill/ExcludedPersonsModal';
import { ExitOnboardingModal } from './containers/interwill/ExitOnboardingModal/ExitOnboardingModal';
import { FullNameModal } from './containers/interwill/FullNameModal';
import { GlossaryModal } from './containers/interwill/GlossaryModal';
import { IWCreateAssetModal } from './containers/interwill/IWCreateAssetModal';
import { NotRegisteredParticipantsModal } from './containers/interwill/NotRegisteredParticipantsModal';
import { ProofOfOwnershipModal } from './containers/interwill/ProofOfOwnershipModal';
import { RecordingConfirmModal } from './containers/interwill/RecordingConfirmModal';
import { RecordingModal } from './containers/interwill/RecordingModal';
import { RecordingUnavailableModal } from './containers/interwill/RecordingUnavailableModal';
import { RecordingUnfinishedModal } from './containers/interwill/RecordingUnfinishedModal';
import { RecordingWarningModal } from './containers/interwill/RecordingWarningModal';
import { RemindersSentModal } from './containers/interwill/RemindersSentModal';
import { ReplaceResidenceModal } from './containers/interwill/ReplaceResidence';
import { ResidenceModal } from './containers/interwill/ResidenceModal';
import { ReturnToEditingModal } from './containers/interwill/ReturnToEditingModal';
import { ReviewUnavailableModal } from './containers/interwill/ReviewUnavailableModal';
import { ScenarioCantProcessModal } from './containers/interwill/ScenarioCantProcessModal';
import { ScenarioConfirmModal } from './containers/interwill/ScenarioConfirmModal';
import { ScenarioDeleteModal } from './containers/interwill/ScenarioDeleteModal';
import { SelectAssetsModal } from './containers/interwill/SelectAssetsModal';
import { SelectBeneficiaryListModal } from './containers/interwill/SelectBeneficiaryListModal';
import { SelectBeneficiaryTypeModal } from './containers/interwill/SelectBeneficiaryTypeModal';
import { SelectCitizenshipModal } from './containers/interwill/SelectCitizenshipModal';
import { SelectProofOfOwnershipModal } from './containers/interwill/SelectProofOfOwnershipModal';
import { SignedWillInfoModal } from './containers/interwill/SignedWillInfoModal';
import { SubstituteHandoverModal } from './containers/interwill/SubstituteHandoverModal';
import { UploadErrorModal } from './containers/interwill/UploadErrorModal';
import { VideoDeletionConfirmModal } from './containers/interwill/VideoDeletionConfirmModal';
import { VideoGuideModal } from './containers/interwill/VideoGuideModal/VideoGuide';
import { VideoPlayerModal } from './containers/interwill/VideoPlayerModal';
import { VideoRecordNextModal } from './containers/interwill/VideoRecordNextModal';
import { VideoRerecordConfirmModal } from './containers/interwill/VideoRerecordConfirmModal';
import { VideoSavedModal } from './containers/interwill/VideoSavedModal';
import { WelcomeModal } from './containers/interwill/WelcomeModal';
import { WillApprovedModal } from './containers/interwill/WillApprovedModal';
import { WitnessVerificationModal } from './containers/interwill/WitnessVerificationModal';
import { InvalidTypeModal } from './containers/InvalidTypeModal';
import { MobileAssetFiltersModal } from './containers/MobileAssetFiltersModal';
import { MobileSelectAssetCategoryModal } from './containers/MobileSelectAssetCategoryModal';
import { PhotoPreviewModal } from './containers/PhotoPreviewModal';
import { BeneficiaryHaveAssetConfirmationModal } from './containers/scenarios/BeneficiaryHaveAssetConfirmation';
import { DeactivateScenarioConfirmationModal } from './containers/scenarios/DeactivateScenarioConfirmation';
import { DeleteScenarioConfirmationModal } from './containers/scenarios/DeleteScenarioConfirmation';
import { EditScenarioConfirmationModal } from './containers/scenarios/EditScenarioConfirmation';
import { ScenarioTestGuideModal } from './containers/scenarios/ScenarioTestGuide';
import { ScenarioTestLaunchModal } from './containers/scenarios/ScenarioTestLaunch';
import { SelectAssetCategory } from './containers/SelectAssetCategory';
import { SelectAttachToModal } from './containers/SelectAttachToModal';
import { SelectBeneficiaryModal } from './containers/SelectBeneficiaryModal';
import { SelectCollectionItemModal } from './containers/SelectCollectionItem';
import { SelectContactModal } from './containers/SelectContactModal';
import { SelectEntitiesModal } from './containers/SelectEntitiesModal';
import { SelectPidTypeModal } from './containers/SelectPidTypeModal';
import { SelectPrivateDocumentCategoryModal } from './containers/SelectPrivateDocumentCategoryModal';
import { SendInviteModal } from './containers/SendInviteModal';
import { SmartImportSuccessModal } from './containers/SmartImportSuccessModal';
import { UnlinkAssetModal } from './containers/UnlinkAssetModal';
import { UpdateCollectionsModal } from './containers/UpdateCollectionsModal';
import { UploadFilesModal } from './containers/UploadFiles';
import { AccessLevelDetailsModal } from './containers/vfo/AccessLevelDetailsModal';
import { AccessLevelModal } from './containers/vfo/AccessLevelModal';
import { AddMembersToCaseModal } from './containers/vfo/AddMembersToCase';
import { AddNewCaseModal } from './containers/vfo/AddNewCase';
import { AddNewTask } from './containers/vfo/AddNewTask';
import { AddToCaseModal } from './containers/vfo/AddToCase';
import { AddVfoDocumentModal } from './containers/vfo/AddVfoDocumentModal';
import { CaseCreatedModal } from './containers/vfo/CaseCreated';
import { ChatInfoModal } from './containers/vfo/ChatInfoModal';
import { DeleteCaseModal } from './containers/vfo/DeleteCaseModal';
import { DeleteDocumentModal } from './containers/vfo/DeleteDocument';
import { DeleteTaskModal } from './containers/vfo/DeleteTaskModal';
import { DiscardTaskModal } from './containers/vfo/DiscardTaskModal';
import { DocumentsFiltersModal } from './containers/vfo/DocumentsFiltersModal';
import { EditTaskModal } from './containers/vfo/EditTaskModal';
import { InvitationSuccessModal } from './containers/vfo/InvitationSuccessModal';
import { InviteMemberModal } from './containers/vfo/InviteMemberModal';
import { MembersFiltersModal } from './containers/vfo/MembersFiltersModal';
import { MessageActionsModal } from './containers/vfo/MessageActionsModal';
import { PrintReportModal } from './containers/vfo/PrintReportModal';
import { RemoveFromCaseModal } from './containers/vfo/RemoveFromCase';
import { RemoveMemberModal } from './containers/vfo/RemoveMember';
import { ResendInvitationModal } from './containers/vfo/ResendInvitation';
import { SelectDocumentFiles } from './containers/vfo/SelectDocumentsFiles';
import { SelectDocumentsToCaseModal } from './containers/vfo/SelectDocumentsToCase';
import { SelectMembersModal } from './containers/vfo/SelectMemberModal';
import { SelectTagModal } from './containers/vfo/SelectTagModal';
import { SetupProfileModal } from './containers/vfo/SetupProfileModal';
import { UploadVfoDocumentModal } from './containers/vfo/UploadVfoDocumentModal';
import { VfoChatEmptyModal } from './containers/vfo/VfoChatEmptyModal';
import { VfoChatModal } from './containers/vfo/VfoChatModal';
import { VfoDocumentsConflictsModal } from './containers/vfo/VfoDocumentsConflictsModal';
import { VfoImportDocumentModal } from './containers/vfo/VfoImportDocumentModal';
import { VfoProfileModal } from './containers/vfo/VfoProfileModal';
import { ModalData } from './types';

const modalsMap = {
  /* */
  /* */
  AccessErrorModal: AccessErrorModal,
  AccessInterwillModal: AccessInterwillModal,
  AccessLevelDetailsModal: AccessLevelDetailsModal,
  AccessLevelModal: AccessLevelModal,
  AccessTutorialModal: AccessTutorialModal,
  AddExecutorModal: AddExecutorModal,
  AddMembersToCaseModal: AddMembersToCaseModal,
  AddMessageModal: AddMessageModal,
  AddNewTaskModal: AddNewTask,
  AddOrEditCaseModal: AddNewCaseModal,
  AddToCaseModal: AddToCaseModal,
  AddVfoDocumentModal: AddVfoDocumentModal,
  AddVideoVerificationModal: AddVideoVerificationModal,
  AddWitnessModal: AddWitnessModal,
  AssetDistributionModal: AssetDistributionModal,
  BeneficiaryHaveAssetConfirmationModal: BeneficiaryHaveAssetConfirmationModal,
  BeneficiaryRelationsModal: BeneficiaryRelationsModal,
  CaseCreatedModal: CaseCreatedModal,
  CitizenshipModal: CitezenshipModal,
  ConfirmApprovalModal: ConfirmApprovalModal,
  ConfirmHandoverModal: ConfirmHandoverModal,
  ConfirmModal: ConfirmModal,
  ConfirmModalV2: ConfirmModalV2,
  CreateBeneficiaryModal: CreateBeneficiaryModal,
  CreateBeneficiaryModalV2: CreateBeneficiaryModalV2,
  CreatePersonalIdentifierModal: CreatePersonalIdentifierModal,
  DeactivateScenarioConfirmationModal: DeactivateScenarioConfirmationModal,
  DelegateToModal: DelegateToModal,
  DeleteAssetsConfirmModal: DeleteAssetsConfirm,
  DeleteCaseModal: DeleteCaseModal,
  DeleteDocumentModal: DeleteDocumentModal,
  DeletePersonalIdentifiersConfirm: DeletePersonalIdentifiersConfirm,
  DeletePrivateDocumentConfirm: DeletePrivateDocumentConfirm,
  DeleteScenarioConfirmationModal: DeleteScenarioConfirmationModal,
  DeleteTaskModal: DeleteTaskModal,
  DeleteTheWillModal: DeleteTheWillModal,
  DiscardTaskModal: DiscardTaskModal,
  DocumentDetailsModal: DocumentDetailsModal,
  DocumentGalleryModal: DocumentGalleryModal,
  DocumentsFiltersModal: DocumentsFiltersModal,
  EditAddress: EditAddressModal,
  EditComment: EditCommentModal,
  EditScenarioConfirmationModal: EditScenarioConfirmationModal,
  EditTaskModal: EditTaskModal,
  EditUnregBeneficiaryModal: EditUnregBeneficiaryModal,
  ExcludedPersonsModal: ExcludedPersonsModal,
  ExitOnboardingModal: ExitOnboardingModal,
  FastCreateBeneficiary: FastCreateBeneficiaryModal,
  FastCreateContact: FastCreateContactModal,
  FilePreviewModal: FilePreviewModal,
  FullNameModal: FullNameModal,
  GlossaryModal: GlossaryModal,
  InboxEmailConfig: InboxEmailConfigModal,
  InboxEmailInfo: InboxEmailInfoModal,
  InterwillCreateEntityModal: InterwillCreateEntityModal,
  InvalidTypeModal: InvalidTypeModal,
  InvitationSuccessModal: InvitationSuccessModal,
  InviteMemberModal: InviteMemberModal,
  IWCreateAssetModal: IWCreateAssetModal,
  MembersFiltersModal: MembersFiltersModal,
  MessageActionsModal: MessageActionsModal,
  MobileAssetFiltersModal: MobileAssetFiltersModal,
  MobileSelectAssetCategoryModal: MobileSelectAssetCategoryModal,
  NotRegisteredParticipantsModal: NotRegisteredParticipantsModal,
  PhotoPreviewModal: PhotoPreviewModal,
  PrintReportModal: PrintReportModal,
  ProofOfOwnershipModal: ProofOfOwnershipModal,
  RecordingConfirmModal: RecordingConfirmModal,
  RecordingModal: RecordingModal,
  RecordingUnavailableModal: RecordingUnavailableModal,
  RecordingUnfinishedModal: RecordingUnfinishedModal,
  RecordingWarningModal: RecordingWarningModal,
  RemindersSentModal: RemindersSentModal,
  RemoveFromCaseModal: RemoveFromCaseModal,
  RemoveMemberModal: RemoveMemberModal,
  ReplaceResidenceModal: ReplaceResidenceModal,
  ResendInvitationModal: ResendInvitationModal,
  ResidenceModal: ResidenceModal,
  ReturnToEditingModal: ReturnToEditingModal,
  ReviewUnavailableModal: ReviewUnavailableModal,
  ScenarioCantProcessModal: ScenarioCantProcessModal,
  ScenarioConfirmModal: ScenarioConfirmModal,
  ScenarioDeleteModal: ScenarioDeleteModal,
  ScenarioTestGuideModal: ScenarioTestGuideModal,
  ScenarioTestLaunchModal: ScenarioTestLaunchModal,
  SelectAssetCategory: SelectAssetCategory,
  SelectAssetsModal: SelectAssetsModal,
  SelectAttachTo: SelectAttachToModal,
  SelectBeneficiary: SelectBeneficiaryModal,
  SelectBeneficiaryListModal: SelectBeneficiaryListModal,
  SelectBeneficiaryTypeModal: SelectBeneficiaryTypeModal,
  SelectCitizenshipModal: SelectCitizenshipModal,
  SelectCollectionItem: SelectCollectionItemModal,
  SelectDocumentFiles: SelectDocumentFiles,
  SelectContact: SelectContactModal,
  SelectDocumentsToCaseModal: SelectDocumentsToCaseModal,
  SelectEntitiesModal: SelectEntitiesModal,
  SelectMembersModal: SelectMembersModal,
  SelectPidTypeModal: SelectPidTypeModal,
  SelectPrivateDocumentCategoryModal: SelectPrivateDocumentCategoryModal,
  SelectProofOfOwnershipModal: SelectProofOfOwnershipModal,
  SelectTagModal: SelectTagModal,
  SendInviteModal: SendInviteModal,
  SetupProfileModal: SetupProfileModal,
  SignedWillInfoModal: SignedWillInfoModal,
  SmartImportSuccessModal: SmartImportSuccessModal,
  SubstituteHandoverModal: SubstituteHandoverModal,
  UnlinkAssetModal: UnlinkAssetModal,
  UpdateCollectionsModal: UpdateCollectionsModal,
  UploadErrorModal: UploadErrorModal,
  UploadFiles: UploadFilesModal,
  ExtractModal: ExtractModal,
  UploadVfoDocumentModal: UploadVfoDocumentModal,
  VfoChatEmptyModal: VfoChatEmptyModal,
  VfoChatInfoModal: ChatInfoModal,
  VfoChatModal: VfoChatModal,
  VfoDocumentsConflictsModal: VfoDocumentsConflictsModal,
  VfoImportDocumentModal: VfoImportDocumentModal,
  VfoProfileModal: VfoProfileModal,
  VideoDeletionConfirmModal: VideoDeletionConfirmModal,
  VideoGuideModal: VideoGuideModal,
  VideoPlayerModal: VideoPlayerModal,
  VideoRecordNextModal: VideoRecordNextModal,
  VideoRerecordConfirmModal: VideoRerecordConfirmModal,
  VideoSavedModal: VideoSavedModal,
  WelcomeModal: WelcomeModal,
  WillApprovedModal: WillApprovedModal,
  WitnessVerificationModal: WitnessVerificationModal,
};

type ModalsRouter = {
  data: ModalData[];
};

export const ModalsRouter: FC<ModalsRouter> = ({ data }) => {
  return data.map((item) => {
    const Component = modalsMap[item.type];

    if (Component) {
      // @ts-ignore
      return <Component {...item} key={item.type} />;
    } else {
      return <InvalidTypeModal type="InvalidTypeModal" modalType={item.type} key={item.type} />;
    }
  });
};
